import React from 'react';
import {  Grid, Typography } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';  // Assuming you're using WSIcons from your project
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate()

 const handleClick =(path:any)=>{
  navigate(path)
 }
  return (
    <Grid sx={{ backgroundColor: '#333', color: '#fff', padding: '1rem', display: 'flex', justifyContent: 'space-between', }}>
      {/* Left side content */}
      <Grid>
        <Typography variant="body2">eZee Suites & Spa</Typography>
        <Typography variant="body2">[7.0.209.015]</Typography>
      </Grid>

      {/* Right side icons, time, and date */}
      <Grid sx={{ display: 'flex', alignItems: 'center' }}>
        {/* Icons */}
        <Grid sx={{ display: 'flex', gap: '1rem' }}> {/* 8px gap between icons */}
          <WSIcons.MessageIcon fontSize="small" /> {/* Replace Icon1, Icon2, etc. with actual icon names */}
          <WSIcons.SettingsIcon fontSize="small" onClick={()=>handleClick('/settings')}/>
          <WSIcons.GTranslateIcon fontSize="small" />
          <WSIcons.ForumIcon fontSize="small" />
        </Grid>

        {/* Time and Date */}
        <Grid sx={{ textAlign: 'unset', marginLeft: '4rem' }}> {/* Adds space between icons and time/date */}
          <Typography variant="body2">05:30 PM</Typography>
          <Typography variant="body2">09-30-2024</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Footer;
